import { CardTitle } from "@/components/ui/card";
import { getIntegrations, Integration } from "@/lib/integrations";
import { useTranslation } from "react-i18next";
import { IntegrationCard } from "./integration-card";
import { RequestIntegrationCard } from "./request-integration-card";

interface IntegrationsGridProps {
  onEarlyAccess: (integrationName: string) => void;
  onRequestIntegration: () => void;
}

export const IntegrationsGrid = ({
  onEarlyAccess,
  onRequestIntegration,
}: IntegrationsGridProps) => {
  const { t } = useTranslation();
  const integrations = getIntegrations(t);

  return (
    <div className="space-y-8">
      {integrations.map((category) => (
        <div key={category.category}>
          <CardTitle className="mb-4 text-lg font-semibold text-gray-900 dark:text-gray-50">
            {category.title}
          </CardTitle>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
            {category.items.map((integration: Integration) => (
              <IntegrationCard
                key={integration.key}
                integration={integration}
                onEarlyAccess={onEarlyAccess}
              />
            ))}
          </div>
        </div>
      ))}

      <div>
        <CardTitle className="mb-4 text-lg font-semibold text-gray-900 dark:text-gray-50">
          {t("team.integrations.notFound.title")}
        </CardTitle>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          <RequestIntegrationCard onRequestIntegration={onRequestIntegration} />
        </div>
      </div>
    </div>
  );
};
